var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex border rounded p-1 p-md-2 mb-3 calendar-container" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-center align-items-center mr-1 mt-2 mt-md-0 mt-sm-2",
          class: {
            "calendar-box": _vm.hasNegative(_vm.value.serviceCostTotalAmt),
            "calendar-box-red": !_vm.hasNegative(_vm.value.serviceCostTotalAmt)
          }
        },
        [_c("span", [_vm._v(_vm._s(_vm.value.assistanceDay))])]
      ),
      _c("div", { staticClass: "pl-1 pr-0 flex-grow-1" }, [
        _c("div", { staticClass: "pt-1 border__bottom--secondary-27 pb-1" }, [
          _c(
            "div",
            { staticClass: "d-flex justify-content-center align-items-center" },
            [
              _c(
                "span",
                {
                  staticClass: "font-13 font-weight-bold",
                  class: {
                    "color-green": _vm.hasNegative(
                      _vm.value.serviceCostTotalAmt
                    ),
                    "color-secondary-28": !_vm.hasNegative(
                      _vm.value.serviceCostTotalAmt
                    )
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("price")(_vm.value.serviceCostTotalAmt)) +
                      " "
                  )
                ]
              )
            ]
          )
        ]),
        _c("div", { staticClass: "d-flex justify-content-center pb-1" }, [
          _c("div", { staticClass: "font-weight-bold font-13" }, [
            _vm._v(_vm._s(_vm.formula(_vm.value)))
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }